import { useAPIRoute } from '../../hooks';
import { useQuery } from 'react-query';
import { NeighborhoodServiceAreaInfo } from 'rwl-shared/dist/models/neighborhood';
type useNeighborhoodProps = {
    accountId: string;
    postCode?: string;
};

export const useNeighborhood = ({
    accountId,
    postCode,
}: useNeighborhoodProps) => {
    const url = useAPIRoute('/serviceareas/neighborhood', 'v1');

    return useQuery<NeighborhoodServiceAreaInfo | undefined>(
        ['neighborhood', accountId, postCode],
        async () => {
            try {
                if (!postCode || !accountId || postCode.trim() === '') {
                    return;
                }
                const result = await fetch(
                    `${url}?` +
                        new URLSearchParams({
                            accountId: accountId,
                            postCode: postCode,
                        }),
                    {
                        method: 'GET',
                    }
                );
                const text = await result.text();
                if (!text) {
                    return undefined;
                }
                return JSON.parse(text) as NeighborhoodServiceAreaInfo;
            } catch (e) {
                console.error('useNeighborhood error:', e);
                throw e;
            }
        },
        {
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
        }
    );
};
